import { Editor, Node, Path } from 'slate';

import types from '../../elements/types';

import HelptapEditor from '../../helpers';

const buttonTypes = [
  types.BUTTON,
  types.AUTHENTICATOR_BUTTON
];

function withButtons(editor) {
  const { insertBreak, deleteBackward } = editor;

  editor.insertBreak = () => {
    const [button] = Editor.nodes(editor, {
      match(node) {
        return buttonTypes.includes(node.type);
      },
      mode: 'lowest'
    });

    if (button) {
      const [buttonNode, buttonPath] = button;
      const isEmpty = Node.string(buttonNode) === '';

      if (isEmpty) {
        HelptapEditor.paragraph.replace(editor, buttonPath);
      } else {
        HelptapEditor.paragraph.insert(editor, Path.next(buttonPath));
      }
    } else {
      insertBreak();
    }
  };

  editor.deleteBackward = (unit) => {
    const [button] = Editor.nodes(editor, {
      match(node) {
        return buttonTypes.includes(node.type);
      },
      mode: 'lowest'
    });

    if (button) {
      const [buttonNode, buttonPath] = button;
      const isEmpty = Node.string(buttonNode) === '';

      if (isEmpty) {
        HelptapEditor.paragraph.replace(editor, buttonPath);
      } else {
        deleteBackward(unit);
      }
    } else {
      deleteBackward(unit);
    }
  };

  return editor;
};

export default withButtons;